import React from "react";
import { func, bool, number } from "prop-types";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "./deleteWatchListEntryModal.css";
import { IconButton } from "@material-ui/core";
import { CloseIcon } from "../../../../assets";

const DeleteWatchListEntryModal = ({ isOpen, toggle, id, handleDelete }) => (
  <React.Fragment>
    <Modal isOpen={isOpen}>
      <ModalHeader
        close={
          <IconButton
            onClick={toggle}
            style={{ marginTop: -10, marginRight: -10 }}
          >
            <CloseIcon />
          </IconButton>
        }
      >
        WatchListEntries HighRiskCountry
      </ModalHeader>
      <ModalBody>Are you sure you want to delete this record?</ModalBody>
      <ModalFooter>
        <Button
          className="delete-watchlist-country-button confirm-button"
          onClick={() => {
            handleDelete(id);
            toggle();
          }}
        >
          Delete
        </Button>
        <Button
          className="delete-watchlist-country-button cancel-button"
          onClick={toggle}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  </React.Fragment>
);

DeleteWatchListEntryModal.propTypes = {
  isOpen: bool.isRequired,
  toggle: func.isRequired,
  id: number.isRequired,
  handleDelete: func.isRequired,
};

export default DeleteWatchListEntryModal;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/components/delete-watch-list-entry-modal/DeleteWatchListEntryModal.jsx